export const ERROR = 'FIRMS/ERROR';
export const FETCH = 'FIRMS/FETCH';
export const SEARCH = 'FIRMS/SEARCH';
export const LOADING = 'FIRMS/LOADING';
export const SET_DATA = 'FIRMS/SET_DATA';
export const SET_PAGE_DETAILS = 'FIRMS/SET_PAGE_DETAILS';
export const SET_TOTAL_FIRMS = 'FIRMS/SET_TOTAL_FIRMS';
export const CREATE_FIRM = 'FIRMS/CREATE_FIRM';
export const FETCH_EDIT_FIRM = 'FIRMS/FETCH_EDIT_FIRM';
export const UPDATE_EDIT_FIRM = 'FIRMS/UPDATE_EDIT_FIRM';
export const SET_EDIT_FIRM_DATA = 'FIRMS/SET_EDIT_FIRM_DATA';
export const CLEAR_EDIT_FIRM_DATA = 'FIRMS/CLEAR_EDIT_FIRM_DATA';

export const error = err => ({ type: ERROR, error: err });
export const fetch = pageDetails => ({ type: FETCH, pageDetails: pageDetails });
export const search = filter => ({ type: SEARCH, filter });
export const loading = isLoading => ({ type: LOADING, loading: isLoading });
export const setData = data => ({ type: SET_DATA, data });
export const setTotalFirms = totalFirms => ({
  type: SET_TOTAL_FIRMS,
  totalFirms,
});
export const setPageDetails = pageDetails => ({
  type: SET_PAGE_DETAILS,
  pageDetails: pageDetails,
});
export const createFirm = (history, bypassDuplicateCheck = false) => ({
  type: CREATE_FIRM,
  history,
  bypassDuplicateCheck,
});
export const fetchEditFirm = firmIdentifiers => ({
  type: FETCH_EDIT_FIRM,
  firmIdentifiers,
});
export const updateEditFirm = (history, firmIdentifiers, bypassDuplicateCheck = false) => ({
  type: UPDATE_EDIT_FIRM,
  history,
  firmIdentifiers,
  bypassDuplicateCheck,
});
export const setEditFirmData = editFirmData => ({ type: SET_EDIT_FIRM_DATA, editFirmData });
export const clearEditFirmData = () => ({ type: CLEAR_EDIT_FIRM_DATA });

